import { v4 as uuidv4 } from 'uuid';
import AWS from 'aws-sdk';
import { postData } from 'src/utils/axios/index';
import { urlMap } from 'src/utils/urls';

import {
  PRE_SIGNED_URL_UPLOAD_PURPOSE_RESUME,
  PRE_SIGNED_URL_UPLOAD_PURPOSE_FILE,
  PRE_SIGNED_URL_FILE_TYPE_PDF,
  PRE_SIGNED_URL_FILE_TYPE_DOCX,
  PRE_SIGNED_URL_FILE_TYPE_DOC,
  PRE_SIGNED_URL_FILE_TYPE_IMAGE,
} from "src/constants";

export const getPresignedUrl = async (uploadPath,fileType,uploadPurpose) => {
  try {
     const url = `${urlMap.generateClientPresignedUrl}`;
     const reqBody = { "key_name":uploadPath, "file_type":fileType,"upload_purpose":uploadPurpose };
     return postData(url, reqBody);
  } catch (error) {
    console.log(error);
  }
}


export const uploadJobDescriptionToS3 = async (
  fileObj,
  fileExtension,
  accept,
) => {
  try {
    const uploadKey = `job-descriptions/${uuidv4()}.${fileExtension}`;
    const docUrl = await uploadFile(fileObj, uploadKey, accept,PRE_SIGNED_URL_UPLOAD_PURPOSE_RESUME);
    return docUrl;
  } catch (error) {
    console.log(error);
  }
  return null;
};

export const uploadImageToS3 = async (
  fileObj,
  folderName,
  accept = 'image/jpeg',
  fileExtension = 'jpeg',
) => {
  try {
    let uploadKey = `images/${uuidv4()}.${fileExtension}`;

    if (folderName) {
      uploadKey = `images/${folderName}/${uuidv4()}.${fileExtension}`;
    }
    console.log('b:', folderName, accept, fileExtension);

    const imageUrl = await uploadFile(fileObj, uploadKey, accept,PRE_SIGNED_URL_UPLOAD_PURPOSE_FILE);

    return imageUrl;
  } catch (error) {
    console.log(error);
  }

  return null;
};

export const uploadResumeToS3 = async (
  fileObj,
  folderName,
  accept = 'application/pdf',
  fileExtension = 'pdf',
) => {
  try {
    const uploadKey = `resumes/${folderName}/${uuidv4()}.${fileExtension}`;
    const resumeUrl = await uploadFile(fileObj, uploadKey, accept,PRE_SIGNED_URL_UPLOAD_PURPOSE_RESUME);
    return resumeUrl;
  } catch (error) {
    console.log(error);
  }

  return null;
};

export const uploadFile = async (fileObj, uploadKey, contentType,uploadPurpose) => {
  try {
    console.log(uploadKey, contentType);
    
    const presignedData = await getPresignedUrl(
      uploadKey,
      contentType === "application/pdf"
        ? PRE_SIGNED_URL_FILE_TYPE_PDF
        : contentType === "image/jpeg"
        ? PRE_SIGNED_URL_FILE_TYPE_IMAGE
        : PRE_SIGNED_URL_FILE_TYPE_PDF,
       uploadPurpose
    );
    if (presignedData && presignedData.presigned_url) {
      const response = await fetch(presignedData.presigned_url, {
        method: "PUT",
        headers: {
          "Content-Type": contentType,
        },
        body: fileObj,
      });
      if (response.ok) {
        return presignedData.final_url;
      } else {
        console.log("Error uploading file to S3:", response.statusText);
        return "";
      }
    }
    
  } catch (error) {
    console.log(error);
  }

  return null;
};
